module.exports = __webpack_public_path__ + "static/img/topBg.053bc7a2.png";